module.exports = __webpack_public_path__ + "img/Energies_du_santerre_80X30.7e759e1d.png";